const newLineRegex = /\n/;

const sanitizeClassName = (className: string): string => {
  if (typeof className === 'string' && newLineRegex.test(className)) {
    return className.replace('\n', ' ');
  }
  return className;
};

export default sanitizeClassName;
